export function GetTodaysDate() {
    const todayDate = new Date();
    const todayNoTime = new Date(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate());
    return todayNoTime;
}

export function GetHumanReadableTimeUntilTomorrow() {
    const now = new Date();
    const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const diffMs = tomorrow.getTime() - now.getTime();

    const totalSeconds = Math.floor(diffMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hours}h ${minutes}m ${seconds}s`;
}

/**
 * Get ordinal suffix for a number (1st, 2nd, 3rd, etc.)
 */
export function getOrdinalSuffix(num: number): string {
    if (num > 3 && num < 21) return 'th';
    switch (num % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
    }
}

/**
 * Format a number with its ordinal suffix (1st, 2nd, 3rd, etc.)
 */
export function formatOrdinal(num: number): string {
    return `${num}${getOrdinalSuffix(num)}`;
}